import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import {
  applyTheme,
  savedTheme,
} from './ui/theme';
import '@fontsource-variable/inter';
import '@fontsource-variable/roboto';
import './ui/app.scss';

// the bars' colour; the scheme itself is already set by index.html
applyTheme(savedTheme());

// Notes not yet pushed live only in OPFS; best-effort storage is the
// browser's to evict under pressure, or after a week unvisited on Safari
navigator.storage?.persisted()
  .then(persisted => persisted || navigator.storage.persist())
  .catch(() => {});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
